import { useCallback, useEffect, useState } from 'react';
import { getStaffDetail, IStaffDetail } from 'api/operation/group';

const useStaffDetail = (userId: number | undefined) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<IStaffDetail | null>(null);

    const fetchData = useCallback(async () => {
        if (!userId) return;
        setLoading(true);
        try {
            const res = await getStaffDetail(userId);
            if (res && !res.error) {
                setData(res.data?.data as IStaffDetail);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [userId]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return { loading, data, refetch: fetchData };
};

export default useStaffDetail;
